module.exports = __webpack_public_path__ + "static/img/2.3b228cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/sp/2.png
// module id = s9pP
// module chunks = 0